export default [
    {
        path: '/yoga',
        name: 'Yoga',
        component: () => import('../../views/yoga/Yoga.vue'),
        meta: {
            title: '布噜空间',
            keepAlive: false,
        }
    },
    {
        path: '/yogaDetails',
        name: 'YogaDetails',
        component: () => import('../../views/yoga/YogaDetails.vue'),
        meta: {
            title: '课程详情',
            keepAlive: false,
        }
    },
    
]


// WEBPACK FOOTER //
// ./src/router/modules/yoga.js